import { render, staticRenderFns } from "./BTableUsersParticipants.vue?vue&type=template&id=5246e8cd&"
import script from "./BTableUsersParticipants.vue?vue&type=script&lang=js&"
export * from "./BTableUsersParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports